import React, { useState } from 'react'
import "../TopNavBar/TopNavBar.css"
import { NavLink } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'
import DynamicSVG from '../DynamicSVG/DynamicSVG'
interface Props {
  OptionsMenuElements?:JSX.Element[],
  children?:JSX.Element
}

export default function TopNavBar({OptionsMenuElements,children}:Props) {
  const [isOpen, setisOpen] = useState(false)
  function ShowDropDown() {
    if (OptionsMenuElements) {
      return (
      <>
          <button className='TopNavBar__MenuBtn' onClick={()=>isOpen?setisOpen(false):setisOpen(true)}>
          <DynamicSVG SvgName={'Plus-Icon'} />
          </button>
          <CSSTransition unmountOnExit in={isOpen} timeout={300} classNames={"TopNavbarMenu"}>
          <ul className='TopNavBar__Menu'>
          {
            OptionsMenuElements?.map((element,i) => {
              return (
              <li key={i} className="TopNavBar__MenuItem" onClick={()=>isOpen?setisOpen(false):setisOpen(true)}>
                {element}
              </li>)
            })
          }
        
        </ul>
      </CSSTransition>
      
      </>
      
    )
    }else{return <></>}
    
  }
  return (
    <>
      <div className='TopNavBar__Container'>
        {children}
        
        {ShowDropDown()}
        
      </div>
      
    </>
    
  )
}
